import React from 'react';

export class TeamMember extends React.Component {
	render() {
		return (
			<li className="col-xlarge-3 col-medium-6">
				<div className="team-item">
					<img src="temp/img/team_placeholder_1.jpg" alt="" className="image" />
					<h3>{this.props.memberName}</h3>
					<p>{this.props.memberRole}</p>
				</div>
			</li>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/AboutUs/TeamMember.js